import React from 'react'
import { TextContent } from '../../../shared/TextContent/TextContent'
import SandboxAccess from './SandboxAccess/SandboxAccess'
import "./GetStarted.scss"
import ProviderAccess from './ProviderAccess/ProviderAccess'
import PayerAccess from './PayerAccess/PayerAccess'
import ThirdPartyAccess from './ThirdPartyAccess/ThirdPartyAccess'
import Scopes from "./Scopes/Scopes"

function GetStarted() {
    return (
        <section className='page-group get-started' id="get-started-section">
            <TextContent
                header={"Get Started"}
                description={"To connect with us, please refer the Sandbox section.This resource guides you on registering in our sandbox environment for testing purposes before transitioning to our production environment. The API documentation provides comprehensive details on how a payer, provider, or a third-party application can establish connections with us, both in the Sandbox and during production."} />
            <SandboxAccess />
            <ProviderAccess />
            <PayerAccess />
            <ThirdPartyAccess />
            <Scopes />
        </section>
    )
}

export default GetStarted